export const FullDealEntryPointBannerForGoogleTexts = {
  title: 'Подберём займ',
  badgeTitleWithTime: 'за 5 минут',
} as const;
